var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookLinked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    fill: "#385A9A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9631 23.6445V28.8001H39.5853C39.9409 28.8001 40.1187 29.1556 40.1187 29.5112L39.4075 32.8889C39.4075 33.0667 39.052 33.2445 38.8742 33.2445H34.9631V46.2223H29.6298V33.4223H26.6076C26.252 33.4223 26.0742 33.2445 26.0742 32.8889V29.5112C26.0742 29.1556 26.252 28.9778 26.6076 28.9778H29.6298V23.1112C29.6298 20.0889 31.9409 17.7778 34.9631 17.7778H39.7631C40.1187 17.7778 40.2964 17.9556 40.2964 18.3112V22.5778C40.2964 22.9334 40.1187 23.1112 39.7631 23.1112H35.4964C35.1409 23.1112 34.9631 23.2889 34.9631 23.6445Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLinked);
export default __webpack_public_path__ + "static/media/facebook-linked.532feac14514977c5400205d57a8a4ec.svg";
export { ForwardRef as ReactComponent };